module.exports = __webpack_public_path__ + "img/photo_safety03.6ff8862e.jpg";